export enum ClaimChannel {
    NotSet = 0,
    MemberRegistration,
    PostRegistration,
    Intake,
    Supplemental,
    SupplementalIntake
}